import { createFileRoute, redirect } from "@tanstack/react-router"

/*
  If you are removing this route, make sure you also move the
  welcome query! It needs to be called in the entry point.
*/

export const Route = createFileRoute(
  "/qr/$qrLookupID/gated/$pamID/$sessionID/"
)({
  beforeLoad: async ({ params }) => {
    throw redirect({
      to: "/qr/$qrLookupID/gated/$pamID/$sessionID/cart",
      params,
      search: { from: Route.id },
    })
  },
})
